(function() {
  'use strict';

  // Filename retained to avoid a loading-order regression in existing templates.
  // This module is exclusively the Buy One, Get One Free builder controller.
  var builder = document.getElementById('buildStackMode');
  if (!builder) return;

  var necklaceMode = document.getElementById('necklaceOnlyMode');

  function pendingCount() {
    var inNecklaceMode = necklaceMode && necklaceMode.style.display !== 'none';
    if (inNecklaceMode) {
      var companions = document.getElementById('necklacePendantItems');
      return 1 + (companions ? companions.querySelectorAll('.dropdown-wrapper').length : 0);
    }
    var count = 0;
    builder.querySelectorAll('.dropdown-wrapper').forEach(function(row) {
      if (!row.classList.contains('dropdown-wrapper--empty')) count += 1;
    });
    return count;
  }

  function projection(count) {
    if (window.Kinsora && window.Kinsora.bogo) return window.Kinsora.bogo.project(count);
    var total = Math.max(0, count);
    return {
      cartCount: 0,
      pendingCount: count,
      totalCount: total,
      freeCount: Math.floor(total / 2),
      needsOne: total % 2 === 1,
      completesPair: total > 0 && total % 2 === 0,
      discount: 0,
      tier: Math.floor(total / 2),
      needed: total % 2 === 1 ? 1 : 2
    };
  }

  function dispatch(state) {
    document.dispatchEvent(new CustomEvent('kinsora:stack-updated', {
      detail: {
        count: state.totalCount,
        pendingCount: state.pendingCount,
        cartCount: state.cartCount || 0,
        freeCount: state.freeCount || 0,
        needsOne: state.needsOne === true,
        completesPair: state.completesPair === true,
        discount: 0,
        tier: state.freeCount || 0,
        nextDiscount: null,
        needed: state.needed,
        tieredEnabled: false,
        promotion: 'bogo'
      },
      bubbles: true
    }));
  }

  var lastCount = -1;
  var lastCartCount = -1;
  var lastState = projection(pendingCount());

  function update(force) {
    var count = pendingCount();
    var state = projection(count);
    if (force || count !== lastCount || state.cartCount !== lastCartCount) {
      lastCount = count;
      lastCartCount = state.cartCount || 0;
      lastState = state;
      dispatch(state);
    }
  }

  new MutationObserver(function() { update(false); }).observe(builder, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-selected', 'data-variant-id', 'style']
  });
  if (necklaceMode) {
    new MutationObserver(function() { update(false); }).observe(necklaceMode, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-selected', 'data-variant-id', 'style']
    });
  }

  document.addEventListener('kinsora:cart-tier-updated', function() { update(true); });
  document.addEventListener('kinsora:cart-bogo-updated', function() { update(true); });
  document.addEventListener('click', function(event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-action], .add-btn, .remove-btn, .delete-btn') : null;
    if (target) setTimeout(function() { update(true); }, 60);
  }, true);

  document.addEventListener('kinsora:stack-updated', function(event) {
    var detail = event.detail || {};
    var freeCount = Math.max(0, parseInt(detail.freeCount, 10) || 0);
    var message;
    if (window.Kinsora && window.Kinsora.bogo && window.Kinsora.bogo.describeProjection) {
      message = window.Kinsora.bogo.describeProjection(detail, 'this selection');
    } else if (detail.needsOne) {
      message = freeCount > 0
        ? freeCount + ' ' + (freeCount === 1 ? 'PRODUCT IS' : 'PRODUCTS ARE') + ' FREE. ADD 1 MORE PRODUCT TO COMPLETE YOUR NEXT PAIR.'
        : 'ADD 1 MORE PRODUCT. THE LOWER-PRICED ONE WILL BE FREE.';
    } else if (freeCount > 0) {
      message = freeCount + ' ' + (freeCount === 1 ? 'PRODUCT IS' : 'PRODUCTS ARE') + ' FREE. ADD 2 MORE PRODUCTS FOR ANOTHER FREE ONE.';
    } else {
      message = 'PICK 2 PRODUCTS — PAY FOR 1.';
    }
    document.querySelectorAll('.upsell-nudge').forEach(function(node) { node.textContent = message; });

    var tabBadge = document.querySelector('.tab-badge');
    if (tabBadge) tabBadge.textContent = 'BOGO FREE';

    var galleryBadge = document.querySelector('.kinsora-discount-badge');
    if (galleryBadge) {
      var text = galleryBadge.querySelector('.kinsora-discount-badge__text');
      galleryBadge.style.opacity = '1';
      galleryBadge.style.transform = 'scale(1)';
      galleryBadge.style.pointerEvents = 'auto';
      if (text) text.textContent = 'BOGO FREE';
    }
  });

  window.KinsoraStack = {
    getCount: function() { return lastState.totalCount || 0; },
    getPendingCount: function() { return lastCount < 0 ? pendingCount() : lastCount; },
    getTier: function() { return lastState; },
    getTiers: function() { return []; },
    isTiered: function() { return false; },
    getSingleDiscount: function() { return 0; },
    isNecklaceDiscountEnabled: function() { return false; }
  };
  window.KinsoraBOGO = window.KinsoraStack;
  update(true);
})();
